<template>
  <div>
    <div class="d-flex flex-wrap align-items-center py-2">
      <b-form-checkbox
        v-model="showFilter"
        button
        button-variant="link text-decoration-none"
      >
        <BIconFilter/>
        {{showFilter ? 'Hide' : 'Show'}} Filters
        <span v-if="filterValComputed" class="badge badge-primary badge-pill">{{Object.values(filterVal).filter(i => i).length}}</span>
      </b-form-checkbox>
      <button type="button"
        v-if="filterValComputed"
        class="btn btn-link text-secondary"
        @click="filterVal = {}"
      >
        <BIconArrowCounterclockwise class="align-middle mr-1"/>
        <span>Reset</span>
      </button>

      <slot/>
    </div>
    <b-collapse v-model="showFilter">
      <div class="form-inline pt-2 pb-3">
        <b-form-input
          class="mb-2 mb-sm-0 mr-sm-3"
          type="search"
          v-model="filterVal.text"
          placeholder="Filter"
        />
        <b-form-radio-group
          class="mb-2 mb-sm-0 mr-sm-3 radio-slider"
          v-model="filterVal.mode"
          :options="filterOptions"
          buttons
          button-variant="outline-secondary"
        ></b-form-radio-group>
      </div>
    </b-collapse>
  </div>
</template>

<script>
import { BIconArrowCounterclockwise, BIconFilter } from 'bootstrap-vue'
import { escapeRegExp } from 'lodash'

export default {
  name: 'EditBatchFilters',
  components: {
    BIconArrowCounterclockwise,
    BIconFilter,
  },
  data() {
    return {
      showFilter: false,
      filterVal: {},
      filterOptions: [
        {value: null, text: 'All'},
        {value: 'hasErrors', text: 'Errors'},
        {value: 'missingImage', text: 'Missing image'},
      ],
    }
  },
  computed: {
    filterValComputed() {
      return Object.values(this.filterVal).some(i => i)
        ? this.filterVal
        : null
    },
  },
  watch: {
    filterValComputed: {
      handler(val) { this.$emit('update:filterValComputed', val) },
      immediate: true,
    },
  },
  methods: {},
}

export function filterFn(item, {text, mode}) {
  if (mode === 'hasErrors' && !hasDataErrors(item)) {
    return false
  }
  if (mode === 'missingImage' && !hasMissingImage(item)) {
    return false
  }
  return Object.values(item).join('\n').match(new RegExp(escapeRegExp(text), 'i'))
}

export function hasDataErrors(item) {
  if (!item.errors) { return false }
  return Boolean(Object.keys(item.errors).filter(i => i !== 'thumb').length)
}
export function hasMissingImage(item) {
  return Boolean(item.errors?.thumb)
}
</script>
